import image1 from '../Image_Icon/Group 87.png';
import image2 from '../Image_Icon/Group 88.png';
import image3 from '../Image_Icon/gift-2.png';
import image4 from '../Image_Icon/hipcravo-5UbIqV58CW8-unsplash.jpg';
import image44 from '../Image_Icon/Group 80.png';
import image5 from '../Image_Icon/daniel-apodaca-WdoQio6HPVA-unsplash.jpg';
import image55 from '../Image_Icon/Group 81.png';
import image6 from '../Image_Icon/penguinuhh-8VI6WwEEEHw-unsplash.jpg';
import image66 from '../Image_Icon/Group 82.png';
import image7 from '../Image_Icon/bruce-mars-gJtDg6WfMlQ-unsplash.png';
import image8 from '../Image_Icon/arthur-edelman-qfjuh4OLdxw-unsplash.jpg';
import image9 from '../Image_Icon/victor-freitas-546919-unsplash.png';
import image10 from '../Image_Icon/baylee-gramling-5m4Z14SDL80-unsplash.jpg';
import image11 from '../Image_Icon/humphrey-muleba-LOA2mTj1vhc-unsplash.jpg';
import image12 from '../Image_Icon/alora-griffiths-TuzrzArccvc-unsplash.jpg';
import image13 from '../Image_Icon/john-fornander-FIu48iuo_4g-unsplash.jpg';
import image14 from '../Image_Icon/sven-mieke-Lx_GDv7VA9M-unsplash.jpg';

export const genderSlot = [
    {gender : 'Female'},
    {gender : 'Male'},
    {gender : 'Others'}
]

export const chooseUsData = [
    {
        id: 1,
        title: 'FREE FITNESS TRAINING',
        image: image1,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore architecto at harum obcaecati eos Cum esse eos doloribus.'
    },
    {
        id: 2,
        title: 'TONS OF CARDIO & STRENGTH',
        image: image2,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore architecto at harum obcaecati eos Cum esse eos doloribus.'
    },
    {
        id: 3,
        title: 'NO COMMITMENT MEMBERSHIP',
        image: image3,
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore architecto at harum obcaecati eos Cum esse eos doloribus.'
    },
]
export const serviceTypeData = [
    {
        id: 1,
        title: 'PROGRESSION',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium quia error quos sit fugiat aut dolor sit amet consectetur.',
        image: image44,
        imagebg: image4
    },
    {
        id: 2,
        title: 'WORKOUT',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium quia error quos sit fugiat aut dolor sit amet consectetur.',
        image: image55,
        imagebg: image5
    },
    {
        id: 3,
        title: 'NUTRITION',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusantium quia error quos sit fugiat aut dolor sit amet consectetur.',
        image: image66,
        imagebg: image6
    },
]

export const trainingProgramData = [
    {
        id: 1,
        name: 'YOGA TRAINING SESSION',
        image: image7
    },
    {
        id: 2,
        name: 'CARDIO TRAINING SESSION',
        image: image8
    }
]
export const classsData = [
    {
        id: 1,
        name: 'PSYCHO TRAINING',
        image: image9
    },
    {
        id: 2,
        name: 'SELF DEFENCE',
        image: image10
    },
    {
        id: 3,
        name: 'ADVANCE GYM',
        image: image11
    },
    {
        id: 4,
        name: 'CARDIO TRAINING',
        image: image12
    },
    {
        id: 5,
        name: 'STRENGTH TRAINING',
        image: image13 
    },
    {
        id: 6,
        name: 'PHYSICAL TRAINING',
        image: image14
    }
]